


























































































































































































import Modal from "../core/Modals/Modal.vue";
import InputField from "../core/Forms/InputField.vue";
import Multiselect from "vue-multiselect";
import { ContactApi } from "../api/ContactApi";
import { Config } from "../utils/Config";

/**
 * Fusion de clients (AW-39) : le client de la fiche est proposé comme
 * Client conservé, l'autre client est absorbé puis envoyé en corbeille.
 */
export default {
    name: "ClientFusionModal",
    components: { Modal, InputField, Multiselect },
    props: {
        showModal: Boolean,
        client: Object,
    },
    data() {
        return {
            ContactApi: new ContactApi(),
            options: [],
            autre: null,
            inverse: false,
            apercu: null,
            choix: {},
            contactsFusionnes: [],
            confirmation: false,
            erreur: null,
            enCours: false,
            multiselectParams: _.merge({}, Config.vueMultiselectParams, {
                selectLabel: "",
            }),
        };
    },
    computed: {
        conserve: function () {
            return this.inverse ? this.autre : this.client;
        },
        absorbe: function () {
            return this.inverse ? this.client : this.autre;
        },
        transferts: function () {
            return _.filter(this.apercu.transferts, function (transfert) {
                return transfert.nombre > 0;
            });
        },
    },
    watch: {
        showModal: function (ouverte) {
            if (ouverte) {
                this.reinitialiser();
                this.chargerOptions();
            }
        },
        autre: function (autre) {
            // Le client propriétaire de l'application n'est jamais absorbé.
            this.inverse = !!(autre && autre.is_app_owner);
            this.chargerApercu();
        },
    },
    methods: {
        reinitialiser() {
            this.autre = null;
            this.inverse = false;
            this.apercu = null;
            this.erreur = null;
            this.confirmation = false;
            this.enCours = false;
        },
        /**
         * Clients du même propriétaire, archivés compris, sauf la fiche
         * elle-même.
         */
        chargerOptions() {
            let self = this;
            self.ContactApi.getAll({ showArchived: true, limit: 100000 }).then(
                function (res) {
                    self.options = _.filter(res.data, function (contact) {
                        return contact.id !== self.client.id;
                    });
                }
            );
        },
        chargerApercu() {
            let self = this;
            self.apercu = null;
            self.erreur = null;
            self.confirmation = false;
            if (!self.autre) {
                return;
            }
            self.ContactApi.apercuFusion(self.conserve.id, self.absorbe.id)
                .then(function (apercu) {
                    self.apercu = apercu;
                    // Le Client conservé par défaut, chaque doublon coché.
                    self.choix = {};
                    _.forEach(apercu.champs, function (champ) {
                        if (champ.en_conflit) {
                            self.$set(self.choix, champ.champ, "conserve");
                        }
                    });
                    self.contactsFusionnes = _.clone(
                        apercu.contacts_en_doublon
                    );
                })
                .catch(function (error) {
                    self.erreur = self.messageErreur(
                        error,
                        "L'aperçu de la fusion est indisponible."
                    );
                });
        },
        inverser() {
            this.inverse = !this.inverse;
            this.chargerApercu();
        },
        fusionner() {
            let self = this;
            self.enCours = true;
            self.ContactApi.fusionner(self.conserve.id, {
                absorbe_id: self.absorbe.id,
                confirmation: self.confirmation,
                choix: self.choix,
                contacts_fusionnes: _.map(
                    self.contactsFusionnes,
                    function (paire) {
                        return {
                            conserve_id: paire.conserve.id,
                            absorbe_id: paire.absorbe.id,
                        };
                    }
                ),
            })
                .then(function (conserve) {
                    // La fiche rechargée ensuite effacerait le message.
                    let suite = function () {
                        self.$emit("fusionne", conserve);
                    };
                    swal(
                        "Les deux clients ont été fusionnés !",
                        "",
                        "success"
                    ).then(suite, suite);
                })
                .catch(function (error) {
                    self.enCours = false;
                    self.erreur = self.messageErreur(
                        error,
                        "La fusion a échoué : aucune donnée n'a été modifiée."
                    );
                });
        },
        fermer() {
            this.$emit("close-modal");
        },
        libelleClient(contact) {
            return (
                contact.nom +
                (contact.type ? " — " + contact.type : "") +
                (contact.archived ? " (archivé)" : "")
            );
        },
        nomContact(contact) {
            return _.trim((contact.prenom || "") + " " + (contact.nom || ""));
        },
        messageErreur(error, defaut: string): string {
            let data = error && error.response ? error.response.data : null;
            return (
                (data && data.message) ||
                (data && data.error && data.error.message) ||
                defaut
            );
        },
    },
};
